export default __webpack_public_path__ + "static/media/plus-white.ff4be5c0.svg";